<template>
  <div>
    <div>
      <div class="header">
        <img class="header-img" src="https://spkg.smartmice.cn/resources/images/official/about/1.jpg">
        <div class="title">
          <div>公司概况</div>
          <img src="https://spkg.smartmice.cn/resources/images/official/common/downBtn.png">
        </div>
      </div>
      <div class="single-row single-row-first">
        <div class="container">
          <div class="row-title">
            <div class="letter">C</div>
            <div class="txt">
              <div class="name">公司概况</div>
              <div class="subname">ompany overview</div>
            </div>
            <img class="header-icon" src="https://spkg.smartmice.cn/resources/images/official/common/doubleLineLeft.png">
          </div>
          <div class="clear"/>
          <div class="content">
            <div class="details_txt">
              智会云（天津）会议展览有限公司是中智商展集团旗下的全资子公司，以国际多元化专业人才为企业核心，借助现代科技与先进理念，专门为企业客户提供全面智慧化解决方案的第三代MICE（Meeting，Incentive，Convention，Exhibition/Event）专业服务，包括平台服务，人才网络，智能硬件等。
              <br>
              <br>
              中智商展集团创立了 “智慧会展”（SMART MICE）构想，率先向MICE3.0时代（MICE+互联网）全面升级。通过 “智会云”平台及衍生数字化工具，构建了全新的商业服务模式，完成了对以会议为主的商务服务链的整合与优化，并在国家相关部委的支持下，建立了覆盖全国的专业人才服务网络，完成平台+人的服务体系搭建，颠覆了传统企业商务服务劳动密集型为主的落后形态。在MICE3.0基础上，再次前瞻性的提出了MICE4.0时代（MICE+人工智能）的原则及发展方向，在智慧会展构想框架下，通过自我颠覆，创造以更先进科技及运营方法为核心的新一代智慧化服务模式。
              <br>
              <br>
              智会云（天津）会议展览有限公司作为中智商展集团旗下的全资子公司，将专注于实现集团的新一代智慧化服务模式。
            </div>
            <div class="details_img">
              <img src="@/assets/img/about/group/01.png">
            </div>
          </div>
        </div>
      </div>
      <div class="double-row">
        <div class="container">
          <div class="row-title">
            <div class="letter">C</div>
            <div class="txt">
              <div class="name">公司定位</div>
              <div class="subname">ompany positioning</div>
            </div>
            <img class="header-icon" src="https://spkg.smartmice.cn/resources/images/official/common/doubleLineRight.jpg">
          </div>
          <div class="clear"/>
          <div class="content">
            <div class="details_img">
              <img src="@/assets/img/about/group/02.png">
            </div>
            <div class="details_txt">
              依托中智商展集团，智会云（天津）会议展览有限公司定位于第三代MICE专业服务公司，努力通过数字化工具和垂直互联网云平台，整合资源优化流程，通过线上+线下的方式，为客户提供节省、高效、透明、智能的MICE解决方案。
              <br>
              <br>
              公司专注于以MICE为主的企业商务服务场景，基于超过20年操作经验与丰富的资源积累，与客户深度战略合作，历经市场检验，在国内率先打磨出具有强大生命力的“绿色会议解决方案”、“会引擎企业会议解决方案”、“活动兔企业会议解决方案”“智能化合规检查”、“智慧场馆解决方案”等系列服务产品，解决了客户会议活动中运作成本高，沟通执行效率低，信息合规不透明及参与者感受差等痛点，同时实现了全国资源与服务覆盖，为客户提供会议、差旅、商宴等一站式智慧化商务服务。
            </div>
          </div>
        </div>
      </div>
      <div class="single-row">
        <div class="container">
          <div class="row-title">
            <div class="letter">M</div>
            <div class="txt">
              <div class="name">经营理念</div>
              <div class="subname">anagement idea</div>
            </div>
            <img class="header-icon" src="https://spkg.smartmice.cn/resources/images/official/common/doubleLineLeft.png">
          </div>
          <div class="clear"/>
          <div class="content">
            <div class="details_txt">
              公司致力于“智慧会展”- 即”SMART MICE”理想的实现。努力通过更加透明公开的市场化经营，通过技术创新，带动整个行业的升级，承担更多的社会责任。
              <br>坚持三个方向：
              <br>1.&nbsp;&nbsp;合规化——坚持正直合规，通过流程及技术手段确保内部员工及外部服务规范透明，符合国家相关法律法规，及行业最高道德标准；
              <br>2.&nbsp;&nbsp;智慧化——基于客户需求，应用先进技术及经营模式，提升自身运营管理能力，对外提供更多增值服务；
              <br>3.&nbsp;&nbsp;落地化——坚持线上资源整合+ 线下人员服务落地的原则，确保产品既能满足企业管理，又有较高的用户体验；
              <br>
            </div>
            <div class="details_img">
              <img src="@/assets/img/about/group/03.png">
            </div>
          </div>
        </div>
      </div>
      <div class="double-row">
        <div class="container">
          <div class="row-title">
            <div class="letter">C</div>
            <div class="txt">
              <div class="name">企业文化</div>
              <div class="subname">orporate culture</div>
            </div>
            <img class="header-icon" src="https://spkg.smartmice.cn/resources/images/official/common/doubleLineRight.jpg">
          </div>
          <div class="clear"/>
          <div class="content">
            <div class="details_img">
              <img src="@/assets/img/about/group/04.png">
            </div>
            <div class="details_txt">
              <p>使命：
                <br>大道智简、让未来提前到来
                <br>
                <br>
                <br>愿景：
                <br>“智慧会展”的创造者、先行者及领导者
                <br>
              </p>
              <p>价值观：
                <br>-&emsp;诚信：以行业高标准规范服务及管理
                <br>-&emsp;协作：与内、外部资源合作共赢
                <br>-&emsp;创新：同步前沿理念及科技，持续升级
                <br>-&emsp;尊重：尊重他人，以自身价值赢得尊重
                <br>-&emsp;感恩：心存感恩，正向同理，善待他人；
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Footer from "@/components/Footer";
export default {
  name: "GroupOverview",
  components: {
    Footer
  }
};
</script>
<style lang="less" scoped>
@import '../../less/service.less';
.single-row-first {
  margin-top: 65px;
}
</style>
